/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from "react";
import Divider from '@mui/material/Divider';
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import LoginMenu from '../../../../components/LoginMenu/LoginMenu';

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import UploadDocumentsTable from './UploadDocumentsTable';


function isEmpty(obj) {

  if (obj == null) return true;

  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  if (typeof obj !== "object") return true;

  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

const useStyles = makeStyles((theme) => ({
  downShift: {
    paddingTop: "18px !important",
  },
  textFieldCard: {
    paddingTop: "0px !important",
  },
  cardcontent: {
    paddingTop: "0px !important",
    paddingLeft: "4px",
    paddingRight: "4px",
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
    fontSize: "2px !important",
    padding: "8px !important",
  },
  asdf: {
    margin: 1000,
  },
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,

    marginRight: 20,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  bigAvatar: {
    margin: 10,
  },
  badgeMargin: {
    margin: theme.spacing.unit * 2,
  },
  inline: {
    display: "inline",
  },
  card: {
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "10px",
  },
  formControl: {
    minWidth: "100%",

  },
  container: {
    marginTop: "100px",
  },
}));


function MyDropzone(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map((file, index) => {
    const size = file.size > 0 ? (file.size / 1000).toFixed(2) : file.size;
    return (
      <Typography key={index} variant="subtitle1" color="primary">
        {file.path} - {size} Kb
        <input type="hidden" name="file_name" value={file.path}></input>
      </Typography>
    )
  });

  let msg = files || [];
  if (msg.length <= 0 || props.files.length <= 0) {
    msg = <Typography variant="subtitle1">
      Please click to select a file or drop your file here
    </Typography>;
  }
  return (
    <div
      style={{ textAlign: "center" }}
      {...getRootProps({ className: "dropzone", onChange: event => props.onChange(event) })}
    >
      <Card style={{ backgroundColor: "#c7c7c7" }}>
        <CardContent style={{
          paddingBottom: 18
        }}>
          <input name="contained-button-file" {...getInputProps()} disabled={props.disabled} />
          {msg}

        </CardContent>
      </Card>
    </div>
  );
}

const UploadDocumentsForm = () => {
  const classes = useStyles();

  const [documentData, setDocumentData] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [documentTypeId, setDocumentTypeId] = useState("");
  const [documentTypeIdError, setDocumentTypeIdError] = useState("");
  const [otherDocumentTypeLabel, setOtherDocumentTypeLabel] = useState("");
  const [otherDocumentTypeLabelError, setOtherDocumentTypeLabelError] = useState("");
  const [files, setFiles] = useState([]);
  const [filesError, setFilesError] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [isNotUploaded, setIsNotUploaded] = useState(false);
  const [firstMsg, setFirstMsg] = useState("");
  const [uploadMsg, setUploadMsg] = useState("");


  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      await getDocumentListData();
      await getData();
      setIsLoading(false);
    };
    loadData();
  }, []);

  const getDocumentListData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRequiredDocumentListView`;
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const json = await res.json();
      if (json.CODE === 1) {
        setDocumentList(json.DATA || []);
      } else {
        alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
      }
    } catch (error) {
      if (error.status == 401) {
        setIsLoginMenu(true);
        setIsReload(true);
      } else {
        alert('Operation Failed, Please try again later.');
      }
      console.log(error);
    }
  };

  const getData = async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsView`;
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const result = await res.json();
      if (result.CODE === 1) {
        setDocumentData(result.DATA || []);
      } else {
        alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
      }
    } catch (error) {
      alert("Operation Failed, Please try again later");
      console.log(error);
    }
  };

  const isFormValid = () => {
    let tempDocumentTypeIdError = "";
    let tempOtherDocumentTypeLabelError = "";
    let tempFilesError = "";
    let isValid = true;

    if (!documentTypeId) {
      isValid = false;
      tempDocumentTypeIdError = "Please select document type.";
    }
    if (documentTypeId == 6) {
      if (!otherDocumentTypeLabel) {
        isValid = false;
        tempOtherDocumentTypeLabelError = "Please enter description.";
      }
    }
    if (files.length <= 0) {
      isValid = false;
      tempFilesError = "Please select a file.";
    }

    setDocumentTypeIdError(tempDocumentTypeIdError);
    setOtherDocumentTypeLabelError(tempOtherDocumentTypeLabelError);
    setFilesError(tempFilesError);

    return isValid;
  };

  const handleSubmitButtonClick = () => {
    if (isFormValid()) {
      document.getElementById("submit-button").click();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    setIsUploading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsUpload`;

    try {
      const res = await fetch(url, {
        method: "POST",
        body: data,
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const result = await res.json();

      if (result.CODE == 1) {
        setFiles([]);
        setFilesError("");
        setDocumentTypeId("");
        setDocumentTypeIdError("");
        setOtherDocumentTypeLabel("");
        setOtherDocumentTypeLabelError("");

        // Refresh data
        getData();
      } else {
        alert(result.CODE + ":" + result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
      }
    } catch (error) {
      if (error.status == 401) {
        setIsLoginMenu(true);
        setIsReload(false);
      } else {
        alert('Operation Failed, Please try again later.');
        console.log(error);
      }
    }
    setIsUploading(false);
  };

  const DownloadFile = (fileName) => {
    const data = new FormData();
    data.append("fileName", fileName);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME
      }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status == 401) {
          setIsLoginMenu(true);
          setIsReload(false);
          return {};
        } else {
          alert('Operation Failed, Please try again later.');
          return {};
        }
      })
      .then((result) => {
        if (!(result instanceof Blob)) return;

        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);

        // Result code checking logic from original code seems misplaced here because result is a Blob
        // But the original code had checks on result.CODE which implies expected JSON sometimes?
        // Usually fetch returns blob only if successful. If error, the backend might return JSON.
        // The original code was: .then((result) => { ... if (result.CODE == 1) ... })
        // If it's a blob, it won't have .CODE. Assuming blob is success.

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFileChange = (event) => {
    const { files = [] } = event.target;
    console.log(files);
    setFiles(files);
    setFilesError("");
  };

  const deleteFile = (id) => {
    const data = new FormData();
    data.append("documentTypeId", id);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsDelete`;

    fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) throw res;
        return res.json();
      })
      .then((result) => {
        console.log(result);
        if (result["CODE"] == 1) {
          getData(); // Refresh data
        } else {
          alert(result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE);
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          setIsLoginMenu(true);
          setIsReload(false);
        } else {
          alert('Operation Failed, Please try again later.');
          console.log(error);
        }
      });
  };

  const getCheck = async () => {
    let documentsData = [];
    let documentsList = [];
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsView`;

    setLoadingCheck(true);

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken")
        })
      });
      if (!res.ok) throw res;
      const json = await res.json();

      if (json.DATA) {
        documentsData = json.DATA || [];
        setDocumentData(documentsData);

        if (localStorage.getItem("isSubmitted") != 1) {
          const urlList = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRequiredDocumentListView`;

          try {
            const resList = await fetch(urlList, {
              method: "GET",
              headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken")
              })
            });
            if (!resList.ok) throw resList;
            const jsonList = await resList.json();
            if (jsonList.DATA) {
              documentsList = jsonList.DATA || [];
            }
          } catch (error) {
            console.log(error);
          }

          let isNotUploadedTemp = false;
          let uploadMsgTemp = '';
          let firstMsgTemp = '';
          let label = "";

          if (documentsData.length <= 0) {
            isNotUploadedTemp = true;
            uploadMsgTemp = '';
            firstMsgTemp = 'Please scan and upload your supporting documents in Document Upload section';
          } else {
            firstMsgTemp = 'Please scan and upload following documents in Document Upload section';
            const pass = documentsData.find(item => item.documentTypeId === 1);
            const cnic = documentsData.find(item => item.documentTypeId === 2);
            const olevel = documentsData.find(item => item.documentTypeId === 9);

            if (isEmpty(pass)) {
              label = documentsList.find(d => d.ID === 1)?.Label || '';
              uploadMsgTemp = `${uploadMsgTemp}${uploadMsgTemp ? ',' : ''} ${label}`;
              isNotUploadedTemp = true;
            }
            if (isEmpty(cnic)) {
              label = documentsList.find(d => d.ID === 2)?.Label || '';
              uploadMsgTemp = `${uploadMsgTemp}${uploadMsgTemp ? ',' : ''} ${label}`;
              isNotUploadedTemp = true;
            }
            if (documentsData[0].degreeId === 32) {
              if (isEmpty(olevel)) {
                label = documentsList.find(d => d.ID === 9)?.Label || '';
                uploadMsgTemp = `${uploadMsgTemp}${uploadMsgTemp ? ',' : ''} ${label}`;
                isNotUploadedTemp = true;
              }
            }
            if ((documentsData[0].degreeId >= 2 && documentsData[0].degreeId <= 9) || documentsData[0].degreeId === 13 || documentsData[0].degreeId === 14) {
              if (isEmpty(olevel)) {
                label = documentsList.find(d => d.ID === 9)?.Label || '';
                uploadMsgTemp = `${uploadMsgTemp}${uploadMsgTemp ? ',' : ''} ${label}`;
                isNotUploadedTemp = true;
              }
            }
            if (!isNotUploadedTemp) {
              window.location.replace('#/dashboard/review');
            }
          }

          setIsNotUploaded(isNotUploadedTemp);
          setUploadMsg(uploadMsgTemp);
          setFirstMsg(firstMsgTemp);
        }
      }
    } catch (error) {
      if (error.status == 401) {
        setIsLoginMenu(true);
        setIsReload(true);
      } else {
        alert('Failed to fetch, Please try again later.');
        console.log(error);
      }
    }

    setLoadingCheck(false);
  };

  const isSaved = localStorage.getItem("isSaved");

  return (
    <Fragment>
      <LoginMenu reload={isReload} open={isLoginMenu} handleClose={() => setIsLoginMenu(false)} />
      <div className={classes.root}>
        <Dialog
          open={isNotUploaded}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Incomplete Documents"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {firstMsg}
              <div> <strong>{uploadMsg}</strong> </div>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              style={{
                marginBottom: 10,
                marginRight: 10,
                // awidth: 150, // Typo in original code?
                width: 150,
                textTransform: "capitalize",
                color: "#303F9F",
                borderColor: "#303F9F",
              }}
              disabled={isLoading} // check if loadingData was meant to be isLoading
              onClick={() => {
                setIsNotUploaded(false);
                setUploadMsg("");
                setFirstMsg("");
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isSaved == 0}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Application Not Found"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please complete and submit your admission application. You would be able to upload supporting documents after submission of your admission application.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              style={{
                marginBottom: 10,
                marginRight: 10,
                width: 150,
                textTransform: "capitalize",
                color: "#303F9F",
                borderColor: "#303F9F",
              }}
              disabled={isLoading}
            >
              <Link style={{ textDecoration: 'none' }} to='/dashboard/admission-application'>
                Go to Admission Application
              </Link>

            </Button>
          </DialogActions>
        </Dialog>
        <div
          style={{
            marginTop: "15px",
            marginBottom: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "96%" }}>
            <form
              id="myform"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div style={{ padding: 10 }}>
                    <Typography
                      style={{
                        color: "#1d5f98",
                        fontWeight: 600,
                        fontSize: 20,
                      }}
                      variant="h5"
                    >
                      Upload Documents
                    </Typography>
                    <Divider />
                    <br></br>
                    <Typography
                      style={{ fontSize: 14, paddingTop: "20px" }}
                      variant="p" // variant p is skipped in MUI v4 docs but might work if customized
                    > Please upload all the required documents here and click “Next” to proceed to the next step.

                    </Typography>
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ paddingLeft: 20, paddingRight: 20 }}
                >
                  <TextField
                    name="documentTypeId"
                    fullWidth
                    label="Document Type"
                    value={documentTypeId}
                    onChange={(e) => {
                      setDocumentTypeId(e.target.value);
                      setDocumentTypeIdError("");
                    }}
                    error={!!documentTypeIdError} // boolean check
                    helperText={documentTypeIdError}
                    required
                    select
                  >
                    {documentList.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <div>&nbsp;</div>
                </Grid>
                {documentTypeId == 6 && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 10,
                      marginTop: '-10px',
                      marginBottom: 20
                    }}
                  >
                    <TextField
                      id="otherDocumentTypeLabel"
                      name="otherDocumentTypeLabel"
                      label="Description"
                      onChange={(e) => {
                        setOtherDocumentTypeLabel(e.target.value);
                        setOtherDocumentTypeLabelError("");
                      }}
                      error={!!otherDocumentTypeLabelError}
                      helperText={otherDocumentTypeLabelError}
                      value={otherDocumentTypeLabel}
                      fullWidth
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  sm={11}
                  style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                >

                  <MyDropzone files={files} onChange={handleFileChange} disabled={isUploading} />
                  <div style={{
                    textAlign: 'center',
                    marginTop: 10
                  }}>
                    <span style={{
                      color: '#ff2d2d'
                    }}>{filesError}</span>
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={1}
                  style={{
                    paddingTop: 10,
                    marginTop: 10,
                  }}
                >
                  <input
                    id="submit-button"
                    type="submit"
                    style={{ display: "none" }}
                  />
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    style={{ width: 75, height: 40 }}
                    onClick={handleSubmitButtonClick}
                    disabled={isUploading}
                  >
                    {isUploading ? (
                      <CircularProgress style={{ color: "white" }} size={24} />
                    ) : (
                      "Upload"
                    )}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}
                >
                  <UploadDocumentsTable rows={documentData}
                    columns={[
                      { key: "documentTypeLabel", label: "Document Type", style: { width: '30%' } },
                      { key: "otherDocumentTypeLabel", label: "Description", style: { width: '30%' } },
                      { key: "uploadedOn", label: "Upload Date", style: { width: '20%' } }
                    ]} onDownload={name => DownloadFile(name)} onDelete={id => deleteFile(id)} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20 }}
                >
                  <Typography
                    style={{ color: "#1d5f98", fontWeight: 600, fontSize: 16, fontStyle: 'italic' }}
                    variant="h5"
                  >
                    Reference Letter (not applicable to Bloomfield Hall School
                    or UCL students)
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 0 }}
                >
                  <Typography style={{ fontSize: 14, paddingTop: "20px" }} variant="body2">
                    Please ask your referee to email us your reference letter at <a href="mailto:admissions@ucl.edu.pk">admissions@ucl.edu.pk</a><b> within 5 working days</b> of submission of your admission application. Your Full Name, Applicant ID and the Programme you Applied for should be mentioned in the email.
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{
                    paddingLeft: 20, paddingRight: 20, paddingTop: 20, display: 'flex',
                    justifyContent: 'flex-end'
                  }}
                >
                  <Button onClick={() => getCheck()} color="primary" variant="contained">
                    {(isLoading || loadingCheck) ? <CircularProgress style={{ color: 'white' }} size={24} /> : 'Next'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UploadDocumentsForm;
